import { theme } from 'styled';

import { IconProps } from './Icon';

export const LocationIcon = ({ width, color }: IconProps): JSX.Element => {
  const DEFAULT_WIDTH = '18';
  const DEFAULT_HEIGHT = '18';
  const DEFAULT_COLOR = theme.colors.text.primary;

  return (
    <svg
      fill={color || DEFAULT_COLOR}
      height={width || DEFAULT_HEIGHT}
      viewBox="0 0 24 24"
      width={width || DEFAULT_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m12 0c-4.962 0-9 4.066-9 9.065 0 7.103 8.154 14.437 8.501 14.745.143.127.321.19.499.19s.356-.063.499-.189c.347-.309 8.501-7.643 8.501-14.746 0-4.999-4.038-9.065-9-9.065zm0 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z" />
    </svg>
  );
};
